import styled from "styled-components";

export const MovementsTableContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }

  .pencilEdit {
    color: ${(props) => props.theme["@secondary-color"]};
    cursor: pointer;
  }

  .ant-table-thead tr .ant-table-selection-column div {
    display: none;
  }

  .ant-checkbox-wrapper {
    display: none;
  }

  .ant-table-row-expand-icon .ant-table-row-expand-icon-expanded button {
    display: none !important;
  }

  .ant-table-header.ant-table-sticky-holder {
    top: 60px !important;
  }

  .ant-table .ant-table-container:after {
    z-index: 2;
  }
`;
